import UIStrings from '@/Utils/UIStrings';

export function getDurationPattern(years: number | null, months: number | null): string {
    const delimiter = '•';

    if (!years || years === 0) {
        return `${delimiter} ${months} ${UIStrings.MonthsShort}`;
    }

    if (!months || months === 0) {
        return `${delimiter} ${years} ${UIStrings.YearsShort}`;
    }

    return `${delimiter} ${years} ${UIStrings.YearsShort} ${months} ${UIStrings.MonthsShort}`;
}

export function calculateDuration(
    isCurrent: boolean | null,
    durationInMonths: number | null,
    startDateMonth: number | null,
    startDateYear: number | null,
): string {
    if (!isCurrent && durationInMonths) {
        const years = Math.trunc(durationInMonths / 12);
        const months = durationInMonths % 12;

        return getDurationPattern(years, months);
    }

    // for current position we can't use durationInMonths as end date is dynamic
    // so we need to calculate it on the fly
    if (isCurrent && startDateYear !== null) {
        // If startDateMonth is null, assume January (month 0 in JavaScript Date)
        const month = startDateMonth === null ? 0 : startDateMonth - 1; // Subtract 1 because JS months are 0-indexed

        // Create start date (using day 1 of the month)
        const startDate = new Date(startDateYear, month, 1);

        // Get today's date
        const today = new Date();

        // Calculate the difference
        let years = today.getFullYear() - startDate.getFullYear();
        let months = today.getMonth() - startDate.getMonth();

        // Adjust if months is negative
        if (months < 0) {
            years--;
            months += 12;
        }
        return getDurationPattern(years, months);
    }

    return '';
}
